import { Component, OnInit } from "@angular/core";
import {
	AnnouncementData,
	AnnouncementService
} from "../../service/announcement.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-announcement-modal",
    templateUrl: "./announcement-modal.component.html",
    styleUrl: "./announcement-modal.component.scss",
    standalone: false
})
export class AnnouncementModalComponent implements OnInit {
	announcementDetail: AnnouncementData;

	constructor(
		public router: Router,
		private announcementService: AnnouncementService
	) {}

	async ngOnInit(): Promise<void> {
		this.announcementDetail = await this.announcementService.getAnnouncement();
	}

	onClose(): void {
		const element = document.querySelector(".modal-container") as HTMLElement;

		element.classList.add("slideOut");

		// Hide element once animation completed
		element.addEventListener(
			"animationend",
			() => {
				element.style.display = "none";
				element.classList.remove("slideOut");
			},
			{ once: true }
		);
	}
}
